import { render, staticRenderFns } from "./team-profile-global.vue?vue&type=template&id=9b377316&"
import script from "./team-profile-global.vue?vue&type=script&lang=js&"
export * from "./team-profile-global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports